export function FormSection({ step, title, description, children, testId }) {
    return (
        <section data-testid={testId} className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-6 md:gap-10">
            <div>
                <p className="text-xs uppercase tracking-[0.22em] text-muted-foreground">Étape {step}</p>
                <h2 className="mt-2 font-display text-2xl text-foreground">{title}</h2>
                <p className="mt-2 text-xs text-muted-foreground">{description}</p>
            </div>
            <div className="space-y-5">{children}</div>
        </section>
    );
}

export function Field({ id, label, required, children }) {
    return (
        <div className="space-y-2">
            <label htmlFor={id} className="text-sm font-medium text-foreground">
                {label} {required && <span className="text-destructive">*</span>}
            </label>
            {children}
        </div>
    );
}
